import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const AdScript = () => {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith("/admin");

  useEffect(() => {
    // Don't load ads on admin routes
    if (isAdminRoute) return;

    // Load Adsterra popunder script
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.src = "//pl28107426.effectivegatecpm.com/4e/d3/4f/4ed34f94a4a967b528ede4f809706fe5.js";
    script.async = true;
    document.head.appendChild(script);

    return () => {
      // Cleanup script on unmount or route change
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
    };
  }, [isAdminRoute]);

  return null;
};

export default AdScript;
